package pl.michal_cyran.portfolio.core.domain

import org.jetbrains.compose.web.css.CSSColorValue

data class Badge(
    val text: String,
    val color: CSSColorValue,
)